/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Account = {
  __typename?: 'Account';
  balance: Scalars['Float'];
  currency: Scalars['String'];
};

export type AccountBalance = {
  __typename?: 'AccountBalance';
  label: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  value: Scalars['Float'];
};

export type AddTenantResponse = MutationResponse & {
  __typename?: 'AddTenantResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  tenant?: Maybe<Tenant>;
};

export type Agent = UiObject &
  User & {
    __typename?: 'Agent';
    balance?: Maybe<Array<Maybe<AccountBalance>>>;
    email: Scalars['String'];
    errors?: Maybe<Array<Maybe<UiError>>>;
    id: Scalars['ID'];
    limit?: Maybe<Scalars['Float']>;
    name: Scalars['String'];
    phone: Scalars['String'];
    role?: Maybe<AgentRole>;
    state?: Maybe<UiState>;
    status: UserStatus;
    superAgent?: Maybe<Agent>;
    tenant: Scalars['ID'];
  };

export type AgentResponse = MutationResponse & {
  __typename?: 'AgentResponse';
  agent?: Maybe<Agent>;
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum AgentRole {
  Admin = 'admin',
  Agent = 'agent',
  Satellite = 'satellite',
  Super = 'super',
}

export type BalanceLedger = {
  __typename?: 'BalanceLedger';
  agentId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  correlationId?: Maybe<Scalars['String']>;
  credit: Scalars['Float'];
  dateCreated: Scalars['String'];
  debit: Scalars['Float'];
  id: Scalars['ID'];
  rateCode: Scalars['String'];
  source: Scalars['String'];
};

export type BasicResponse = MutationResponse & {
  __typename?: 'BasicResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Bill = {
  __typename?: 'Bill';
  amount?: Maybe<Scalars['Float']>;
  billNumber?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  merchant?: Maybe<Scalars['String']>;
  payItemDesc?: Maybe<Scalars['String']>;
  payItemId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  serviceName?: Maybe<Scalars['String']>;
  serviceNumber?: Maybe<Scalars['String']>;
};

export type CollectionInfo = {
  __typename?: 'CollectionInfo';
  agentName: Scalars['String'];
  commission: Scalars['Float'];
  email?: Maybe<Scalars['String']>;
  exchangeKey?: Maybe<Scalars['String']>;
  fromAmount: Scalars['Float'];
  managerEmail?: Maybe<Scalars['String']>;
  managerName?: Maybe<Scalars['String']>;
  primaryCurrency?: Maybe<Scalars['String']>;
  secondaryCurrency?: Maybe<Scalars['String']>;
  toAmount: Scalars['Float'];
};

export type CollectionReport = {
  __typename?: 'CollectionReport';
  collections?: Maybe<Array<Maybe<CollectionInfo>>>;
  keys?: Maybe<Array<Maybe<CurrencyKey>>>;
  summary: Array<CollectionSummary>;
  totals: Array<CollectionSummary>;
};

export type CollectionSummary = {
  __typename?: 'CollectionSummary';
  description: Scalars['String'];
  exchangeKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCurrency: Scalars['Boolean'];
  name: Scalars['String'];
  primaryCurrency?: Maybe<Scalars['String']>;
  primaryValue: Scalars['Float'];
  secondaryCurrency?: Maybe<Scalars['String']>;
  secondaryVaue: Scalars['Float'];
  summaryType: Scalars['String'];
};

export type CurrencyKey = {
  __typename?: 'CurrencyKey';
  exchangeKey: Scalars['String'];
  fromCurrency: Scalars['String'];
  toCurrency: Scalars['String'];
};

export enum DestinationCurrency {
  Cdf = 'cdf',
  Xaf = 'xaf',
}

export type FundTenantRateResponse = MutationResponse & {
  __typename?: 'FundTenantRateResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type HistoricalUser = {
  __typename?: 'HistoricalUser';
  recipientName?: Maybe<Scalars['String']>;
  recipientPhone?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  senderPhone?: Maybe<Scalars['String']>;
};

export type I18nText = {
  __typename?: 'I18nText';
  language: Scalars['String'];
  localText?: Maybe<Scalars['String']>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAgent?: Maybe<AgentResponse>;
  addRate?: Maybe<RateResponse>;
  addTenant?: Maybe<AddTenantResponse>;
  addTransaction?: Maybe<TransactionResponse>;
  addUser?: Maybe<RegisteredUserResponse>;
  cancelTransaction?: Maybe<TransactionResponse>;
  clearAgentErrors?: Maybe<BasicResponse>;
  clearRateErrors?: Maybe<BasicResponse>;
  clearTenantErrors?: Maybe<BasicResponse>;
  clearTransactionErrors?: Maybe<BasicResponse>;
  clearUserErrors?: Maybe<BasicResponse>;
  confirmAndSubmitTransaction?: Maybe<TransactionResponse>;
  confirmTransaction?: Maybe<TransactionResponse>;
  deactivateAgent?: Maybe<BasicResponse>;
  deactivateTenant?: Maybe<BasicResponse>;
  deleteRate?: Maybe<BasicResponse>;
  fundTenantRate?: Maybe<FundTenantRateResponse>;
  registerAgent?: Maybe<BasicResponse>;
  resetAgentBalance?: Maybe<AgentResponse>;
  setAdminAgentTenant?: Maybe<BasicResponse>;
  submitTransaction?: Maybe<TransactionResponse>;
  updateAgent?: Maybe<AgentResponse>;
  updateRate?: Maybe<RateResponse>;
  updateTenant?: Maybe<UpdateTenantResponse>;
  updateTransaction?: Maybe<TransactionResponse>;
  updateUser?: Maybe<RegisteredUserResponse>;
};

export type MutationAddAgentArgs = {
  email: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  role: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
};

export type MutationAddRateArgs = {
  destination: Scalars['String'];
  rate: Scalars['Float'];
  source: Scalars['String'];
  tenantId: Scalars['String'];
};

export type MutationAddTenantArgs = {
  code: Scalars['String'];
  commission: Scalars['Float'];
  currency: Scalars['String'];
  duplicateThreshold: Scalars['Int'];
  logo?: InputMaybe<Scalars['String']>;
  maxBonus: Scalars['Int'];
  name: Scalars['String'];
  rateChangeThreshold1?: InputMaybe<Scalars['Int']>;
  rateChangeThreshold2?: InputMaybe<Scalars['Int']>;
  rateChangeThreshold3?: InputMaybe<Scalars['Int']>;
  receiptFootnote?: InputMaybe<Scalars['String']>;
  receiptLabel: Scalars['String'];
  receiptLineOne?: InputMaybe<Scalars['String']>;
  receiptLineTwo?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MutationAddTransactionArgs = {
  billAmount?: InputMaybe<Scalars['Float']>;
  billCustomerNumber?: InputMaybe<Scalars['String']>;
  billDate?: InputMaybe<Scalars['String']>;
  billDueDate?: InputMaybe<Scalars['String']>;
  billMerchant?: InputMaybe<Scalars['String']>;
  billNumber?: InputMaybe<Scalars['String']>;
  billPayItemDesc?: InputMaybe<Scalars['String']>;
  billPayItemId?: InputMaybe<Scalars['String']>;
  billServiceId?: InputMaybe<Scalars['String']>;
  billServiceName?: InputMaybe<Scalars['String']>;
  billServiceNumber?: InputMaybe<Scalars['String']>;
  destinationPhone: Scalars['String'];
  exchangeRate: Scalars['Float'];
  isBonus: Scalars['Boolean'];
  purpose: Scalars['String'];
  receiveAmount: Scalars['Float'];
  receiveCurrency: DestinationCurrency;
  recipientId: Scalars['String'];
  recipientName: Scalars['String'];
  sendAmount: Scalars['Float'];
  sendCurrency: SendCurrency;
  sendMode: SendMode;
  senderId: Scalars['String'];
  senderName: Scalars['String'];
  sendingPhone: Scalars['String'];
};

export type MutationAddUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  sender?: InputMaybe<Scalars['String']>;
};

export type MutationCancelTransactionArgs = {
  id: Scalars['ID'];
};

export type MutationClearAgentErrorsArgs = {
  id: Scalars['ID'];
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type MutationClearRateErrorsArgs = {
  id: Scalars['ID'];
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type MutationClearTenantErrorsArgs = {
  id: Scalars['ID'];
};

export type MutationClearTransactionErrorsArgs = {
  id: Scalars['ID'];
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type MutationClearUserErrorsArgs = {
  id: Scalars['ID'];
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type MutationConfirmAndSubmitTransactionArgs = {
  id: Scalars['ID'];
};

export type MutationConfirmTransactionArgs = {
  id: Scalars['ID'];
};

export type MutationDeactivateAgentArgs = {
  id: Scalars['ID'];
  tenantId?: InputMaybe<Scalars['String']>;
};

export type MutationDeactivateTenantArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteRateArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type MutationFundTenantRateArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  tenantId: Scalars['String'];
};

export type MutationRegisterAgentArgs = {
  agentToken: Scalars['String'];
};

export type MutationResetAgentBalanceArgs = {
  id: Scalars['ID'];
};

export type MutationSetAdminAgentTenantArgs = {
  id: Scalars['ID'];
  tenantId: Scalars['String'];
};

export type MutationSubmitTransactionArgs = {
  id: Scalars['ID'];
};

export type MutationUpdateAgentArgs = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateRateArgs = {
  id: Scalars['ID'];
  rate: Scalars['Float'];
  tenantId: Scalars['ID'];
};

export type MutationUpdateTenantArgs = {
  code?: InputMaybe<Scalars['String']>;
  commission?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  duplicateThreshold?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  logo?: InputMaybe<Scalars['String']>;
  maxBonus?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  rateChangeThreshold1?: InputMaybe<Scalars['Int']>;
  rateChangeThreshold2?: InputMaybe<Scalars['Int']>;
  rateChangeThreshold3?: InputMaybe<Scalars['Int']>;
  receiptFootnote?: InputMaybe<Scalars['String']>;
  receiptLabel?: InputMaybe<Scalars['String']>;
  receiptLineOne?: InputMaybe<Scalars['String']>;
  receiptLineTwo?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateTransactionArgs = {
  billAmount?: InputMaybe<Scalars['Float']>;
  billCustomerNumber?: InputMaybe<Scalars['String']>;
  billDate?: InputMaybe<Scalars['String']>;
  billDueDate?: InputMaybe<Scalars['String']>;
  billMerchant?: InputMaybe<Scalars['String']>;
  billNumber?: InputMaybe<Scalars['String']>;
  billPayItemDesc?: InputMaybe<Scalars['String']>;
  billPayItemId?: InputMaybe<Scalars['String']>;
  billServiceId?: InputMaybe<Scalars['String']>;
  billServiceName?: InputMaybe<Scalars['String']>;
  billServiceNumber?: InputMaybe<Scalars['String']>;
  destinationPhone?: InputMaybe<Scalars['String']>;
  exchangeRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  isBonus?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<Scalars['String']>;
  receiveAmount?: InputMaybe<Scalars['Float']>;
  receiveCurrency?: InputMaybe<DestinationCurrency>;
  recipientId?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
  sendAmount?: InputMaybe<Scalars['Float']>;
  sendCurrency?: InputMaybe<SendCurrency>;
  sendMode?: InputMaybe<SendMode>;
  senderId?: InputMaybe<Scalars['String']>;
  senderName?: InputMaybe<Scalars['String']>;
  sendingPhone?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type MutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PhoneVerification = {
  __typename?: 'PhoneVerification';
  merchantType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountBalance?: Maybe<Array<Maybe<AccountBalance>>>;
  agent?: Maybe<Agent>;
  agentTransactions?: Maybe<Array<Maybe<Transaction>>>;
  agentUsageReport?: Maybe<CollectionReport>;
  agents?: Maybe<Array<Maybe<Agent>>>;
  balanceLedger?: Maybe<Array<Maybe<BalanceLedger>>>;
  countTransactions?: Maybe<Scalars['Int']>;
  exportTransactions?: Maybe<Scalars['String']>;
  globalUsageReport?: Maybe<CollectionReport>;
  isValidAgent?: Maybe<Scalars['Boolean']>;
  rate?: Maybe<Rate>;
  rates?: Maybe<Array<Maybe<Rate>>>;
  receiptReport?: Maybe<Receipt>;
  satelliteAgents?: Maybe<Array<Maybe<Agent>>>;
  service?: Maybe<TransactionService>;
  serviceBills?: Maybe<Array<Maybe<ServiceBill>>>;
  services?: Maybe<Array<Maybe<TransactionService>>>;
  tenant?: Maybe<Tenant>;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  transaction?: Maybe<Transaction>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  user?: Maybe<RegisteredUser>;
  users?: Maybe<Array<Maybe<RegisteredUser>>>;
  verifyPhone?: Maybe<PhoneVerification>;
};

export type QueryAccountBalanceArgs = {
  id?: InputMaybe<Scalars['ID']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type QueryAgentArgs = {
  id?: InputMaybe<Scalars['ID']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type QueryAgentTransactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  startPage?: InputMaybe<Scalars['Int']>;
};

export type QueryAgentUsageReportArgs = {
  agentId: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type QueryAgentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  startPage?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type QueryBalanceLedgerArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type QueryCountTransactionsArgs = {
  recipientId: Scalars['String'];
  senderId: Scalars['String'];
};

export type QueryExportTransactionsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type QueryGlobalUsageReportArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type QueryIsValidAgentArgs = {
  email: Scalars['String'];
};

export type QueryRateArgs = {
  id: Scalars['ID'];
  tenantId?: InputMaybe<Scalars['String']>;
};

export type QueryRatesArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};

export type QueryReceiptReportArgs = {
  id: Scalars['ID'];
};

export type QuerySatelliteAgentsArgs = {
  agentId?: InputMaybe<Scalars['String']>;
};

export type QueryServiceArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryServiceBillsArgs = {
  merchant?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['Int']>;
  serviceNumber?: InputMaybe<Scalars['String']>;
};

export type QueryTenantArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryTransactionArgs = {
  id: Scalars['ID'];
};

export type QueryTransactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  startPage?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type QueryUsersArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  startPage?: InputMaybe<Scalars['Int']>;
  viewType?: InputMaybe<Scalars['String']>;
};

export type QueryVerifyPhoneArgs = {
  phoneNumber: Scalars['String'];
};

export type Rate = UiObject & {
  __typename?: 'Rate';
  code?: Maybe<Scalars['String']>;
  destination: Scalars['String'];
  errors?: Maybe<Array<Maybe<UiError>>>;
  id: Scalars['ID'];
  rate: Scalars['Float'];
  source: Scalars['String'];
  state?: Maybe<UiState>;
  tenant: Scalars['ID'];
};

export type RateResponse = MutationResponse & {
  __typename?: 'RateResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  rate?: Maybe<Rate>;
  success: Scalars['Boolean'];
};

export type Receipt = {
  __typename?: 'Receipt';
  header: ReceiptHeader;
  remitance: Remitance;
  transaction: ReceiptTransaction;
};

export type ReceiptHeader = {
  __typename?: 'ReceiptHeader';
  baseCurrency: Scalars['String'];
  billDate?: Maybe<Scalars['String']>;
  billNumber?: Maybe<Scalars['String']>;
  billServiceName?: Maybe<Scalars['String']>;
  billServiceNumber?: Maybe<Scalars['String']>;
  clientName: Scalars['String'];
  clientType: Scalars['String'];
  date: Scalars['String'];
  dateName: Scalars['String'];
  dueDate?: Maybe<Scalars['String']>;
  isBonus: Scalars['Boolean'];
  merchant?: Maybe<Scalars['String']>;
  purpose: Scalars['String'];
  receiptFootnote?: Maybe<Scalars['String']>;
  receiptLabel: Scalars['String'];
  receiptLineOne?: Maybe<Scalars['String']>;
  receiptLineTwo?: Maybe<Scalars['String']>;
  receiptNumber: Scalars['String'];
  status: Scalars['String'];
  submittedAgentEmail: Scalars['String'];
  submittedAgentId: Scalars['String'];
  submittedAgentName: Scalars['String'];
  submittedAgentPhone?: Maybe<Scalars['String']>;
  tenantCode?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type ReceiptTransaction = {
  __typename?: 'ReceiptTransaction';
  receiveCurrency: Scalars['String'];
  receiverName: Scalars['String'];
  receiverPhone: Scalars['String'];
  sendCurrency: Scalars['String'];
  senderName: Scalars['String'];
  senderPhone: Scalars['String'];
};

export type RegisteredUser = UiObject &
  User & {
    __typename?: 'RegisteredUser';
    email?: Maybe<Scalars['String']>;
    errors?: Maybe<Array<Maybe<UiError>>>;
    id: Scalars['ID'];
    name: Scalars['String'];
    phone: Scalars['String'];
    sender?: Maybe<Scalars['String']>;
    senderRegisteredUser?: Maybe<RegisteredUser>;
    state?: Maybe<UiState>;
    status: UserStatus;
    tenant: Scalars['ID'];
    type: Scalars['String'];
  };

export type RegisteredUserResponse = MutationResponse & {
  __typename?: 'RegisteredUserResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  user?: Maybe<RegisteredUser>;
};

export type Remitance = {
  __typename?: 'Remitance';
  exchangeRate: Scalars['Float'];
  feeAmount: Scalars['Float'];
  receiveAmount: Scalars['Float'];
  sendAmount: Scalars['Float'];
};

export type SearchCriteria = {
  __typename?: 'SearchCriteria';
  pageSize?: Maybe<Scalars['Int']>;
  startPage?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export enum SendCurrency {
  Cad = 'cad',
  Eur = 'eur',
  Gbp = 'gbp',
  Usd = 'usd',
}

export enum SendMode {
  Receive = 'RECEIVE',
  Send = 'SEND',
}

export type ServiceBill = {
  __typename?: 'ServiceBill';
  amountLocalCur: Scalars['Float'];
  amountType: Scalars['String'];
  billDate?: Maybe<Scalars['String']>;
  billDueDate?: Maybe<Scalars['String']>;
  billMonth: Scalars['String'];
  billNumber: Scalars['String'];
  billType?: Maybe<Scalars['String']>;
  billYear: Scalars['String'];
  customerNumber?: Maybe<Scalars['String']>;
  localCur: Scalars['String'];
  merchant: Scalars['String'];
  optNmb?: Maybe<Scalars['Int']>;
  optStrg?: Maybe<Scalars['String']>;
  payItemDescr?: Maybe<Scalars['String']>;
  payItemId: Scalars['String'];
  payOrder?: Maybe<Scalars['Int']>;
  penaltyAmount?: Maybe<Scalars['Float']>;
  serviceNumber: Scalars['String'];
  serviceid: Scalars['Int'];
};

export type Setting = {
  __typename?: 'Setting';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Tenant = UiObject & {
  __typename?: 'Tenant';
  agents?: Maybe<Array<Maybe<Agent>>>;
  code?: Maybe<Scalars['String']>;
  commission: Scalars['Float'];
  currency: Scalars['String'];
  duplicateThreshold: Scalars['Int'];
  errors?: Maybe<Array<Maybe<UiError>>>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  maxBonus: Scalars['Int'];
  name: Scalars['String'];
  rateChangeThreshold1?: Maybe<Scalars['Int']>;
  rateChangeThreshold2?: Maybe<Scalars['Int']>;
  rateChangeThreshold3?: Maybe<Scalars['Int']>;
  rates?: Maybe<Array<Maybe<Rate>>>;
  receiptFootnote?: Maybe<Scalars['String']>;
  receiptLabel: Scalars['String'];
  receiptLineOne?: Maybe<Scalars['String']>;
  receiptLineTwo?: Maybe<Scalars['String']>;
  state?: Maybe<UiState>;
  status: TenantStatus;
  type: Scalars['String'];
};

export enum TenantStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type Transaction = UiObject & {
  __typename?: 'Transaction';
  bill?: Maybe<Bill>;
  dateCreated: Scalars['String'];
  errors?: Maybe<Array<Maybe<UiError>>>;
  exchangeRate: Scalars['Float'];
  historicals?: Maybe<HistoricalUser>;
  id: Scalars['ID'];
  isBonus?: Maybe<Scalars['Boolean']>;
  ptn?: Maybe<Scalars['String']>;
  purpose: Scalars['String'];
  received: Money;
  recipient?: Maybe<User>;
  relevantAgent?: Maybe<Agent>;
  requestCount?: Maybe<Scalars['Int']>;
  sendMode: SendMode;
  sender?: Maybe<User>;
  sent: Money;
  state?: Maybe<UiState>;
  status: TransactionStatus;
  tenant: Scalars['ID'];
  transactionType?: Maybe<Scalars['String']>;
};

export type TransactionResponse = MutationResponse & {
  __typename?: 'TransactionResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transaction?: Maybe<Transaction>;
};

export type TransactionService = {
  __typename?: 'TransactionService';
  category: Scalars['String'];
  country: Scalars['String'];
  denomination?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  hint?: Maybe<Array<Maybe<I18nText>>>;
  isReqCustomerAddress?: Maybe<Scalars['Boolean']>;
  isReqCustomerName?: Maybe<Scalars['Boolean']>;
  isReqCustomerNumber?: Maybe<Scalars['Boolean']>;
  isReqServiceNumber?: Maybe<Scalars['Boolean']>;
  isVerifiable?: Maybe<Scalars['Boolean']>;
  labelCustomerNumber?: Maybe<Array<Maybe<I18nText>>>;
  labelServiceNumber?: Maybe<Array<Maybe<I18nText>>>;
  localCur: Scalars['String'];
  merchant: Scalars['String'];
  serviceid: Scalars['Int'];
  status: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  validationMask?: Maybe<Scalars['String']>;
};

export enum TransactionStatus {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Creating = 'CREATING',
  Errored = 'ERRORED',
  Pending = 'PENDING',
  Requested = 'REQUESTED',
  Reversed = 'REVERSED',
  Submitted = 'SUBMITTED',
  Success = 'SUCCESS',
}

export type UiError = {
  __typename?: 'UiError';
  code: Scalars['Int'];
  devMsg?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type UiObject = {
  errors?: Maybe<Array<Maybe<UiError>>>;
  state?: Maybe<UiState>;
};

export enum UiState {
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Errored = 'ERRORED',
  Updating = 'UPDATING',
}

export type UpdateTenantResponse = MutationResponse & {
  __typename?: 'UpdateTenantResponse';
  code: Scalars['String'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  tenant?: Maybe<Tenant>;
};

export type User = {
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  status: UserStatus;
  tenant: Scalars['ID'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Registered = 'REGISTERED',
  Suspended = 'SUSPENDED',
}

export enum UserType {
  Recipient = 'recipient',
  Sender = 'sender',
}

export type IsValidAgentQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type IsValidAgentQuery = {
  __typename?: 'Query';
  isValidAgent?: boolean | null;
};

export type RegisterAgentMutationVariables = Exact<{
  agentToken: Scalars['String'];
}>;

export type RegisterAgentMutation = {
  __typename?: 'Mutation';
  registerAgent?: {
    __typename?: 'BasicResponse';
    success: boolean;
    message: string;
  } | null;
};

export type MyClientsSearchResultFragment = {
  __typename?: 'RegisteredUser';
  id: string;
  email?: string | null;
  name: string;
  phone: string;
  sender?: string | null;
  type: string;
  senderRegisteredUser?: {
    __typename?: 'RegisteredUser';
    id: string;
    name: string;
    phone: string;
  } | null;
} & { ' $fragmentName'?: 'MyClientsSearchResultFragment' };

export type SearchMyClientsUsersQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  viewType?: InputMaybe<Scalars['String']>;
}>;

export type SearchMyClientsUsersQuery = {
  __typename?: 'Query';
  users?: Array<
    | ({ __typename?: 'RegisteredUser' } & {
        ' $fragmentRefs'?: {
          MyClientsSearchResultFragment: MyClientsSearchResultFragment;
        };
      })
    | null
  > | null;
};

export type Tenant_RowFragmentFragment = {
  __typename?: 'Tenant';
  name: string;
  code?: string | null;
  id: string;
  type: string;
  commission: number;
  maxBonus: number;
  duplicateThreshold: number;
  rateChangeThreshold1?: number | null;
  rateChangeThreshold2?: number | null;
  rateChangeThreshold3?: number | null;
  currency: string;
  logo?: string | null;
  receiptLabel: string;
  receiptLineOne?: string | null;
  receiptLineTwo?: string | null;
  receiptFootnote?: string | null;
  status: TenantStatus;
} & { ' $fragmentName'?: 'Tenant_RowFragmentFragment' };

export type GetTenantsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTenantsQuery = {
  __typename?: 'Query';
  tenants?: Array<
    | ({ __typename?: 'Tenant' } & {
        ' $fragmentRefs'?: {
          Tenant_RowFragmentFragment: Tenant_RowFragmentFragment;
        };
      })
    | null
  > | null;
};

export type ClientAgent_ItemFragmentFragment = {
  __typename?: 'Agent';
  id: string;
  email: string;
  name: string;
  phone: string;
  role?: AgentRole | null;
  limit?: number | null;
  status: UserStatus;
  superAgent?: {
    __typename?: 'Agent';
    id: string;
    email: string;
    name: string;
  } | null;
} & { ' $fragmentName'?: 'ClientAgent_ItemFragmentFragment' };

export type AgentsQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;

export type AgentsQuery = {
  __typename?: 'Query';
  agents?: Array<
    | ({ __typename?: 'Agent' } & {
        ' $fragmentRefs'?: {
          ClientAgent_ItemFragmentFragment: ClientAgent_ItemFragmentFragment;
        };
      })
    | null
  > | null;
};

export type DeactivateAgentMutationVariables = Exact<{
  agentId: Scalars['ID'];
}>;

export type DeactivateAgentMutation = {
  __typename?: 'Mutation';
  deactivateAgent?: {
    __typename?: 'BasicResponse';
    code: string;
    message: string;
    success: boolean;
  } | null;
};

export type ClientRate_ItemFragmentFragment = {
  __typename?: 'Rate';
  id: string;
  code?: string | null;
  source: string;
  destination: string;
  rate: number;
} & { ' $fragmentName'?: 'ClientRate_ItemFragmentFragment' };

export type RatesQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;

export type RatesQuery = {
  __typename?: 'Query';
  rates?: Array<
    | ({ __typename?: 'Rate' } & {
        ' $fragmentRefs'?: {
          ClientRate_ItemFragmentFragment: ClientRate_ItemFragmentFragment;
        };
      })
    | null
  > | null;
};

export type DeleteRateMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  rateId: Scalars['ID'];
}>;

export type DeleteRateMutation = {
  __typename?: 'Mutation';
  deleteRate?: {
    __typename?: 'BasicResponse';
    code: string;
    message: string;
    success: boolean;
  } | null;
};

export type ReadTenantForRateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type ReadTenantForRateQuery = {
  __typename?: 'Query';
  tenant?: { __typename?: 'Tenant'; currency: string } | null;
};

export type GetBalanceLedgerReportQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
}>;

export type GetBalanceLedgerReportQuery = {
  __typename?: 'Query';
  balanceLedger?: Array<{
    __typename?: 'BalanceLedger';
    dateCreated: string;
    id: string;
    debit: number;
    credit: number;
    rateCode: string;
    comment?: string | null;
    source: string;
    agentId?: string | null;
    correlationId?: string | null;
  } | null> | null;
};

export type GetAgentUsageReportQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
  agentId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
}>;

export type GetAgentUsageReportQuery = {
  __typename?: 'Query';
  agentUsageReport?: {
    __typename?: 'CollectionReport';
    keys?: Array<{
      __typename?: 'CurrencyKey';
      toCurrency: string;
      fromCurrency: string;
      exchangeKey: string;
    } | null> | null;
    collections?: Array<{
      __typename?: 'CollectionInfo';
      agentName: string;
      exchangeKey?: string | null;
      primaryCurrency?: string | null;
      secondaryCurrency?: string | null;
      fromAmount: number;
      toAmount: number;
      commission: number;
      email?: string | null;
      managerName?: string | null;
      managerEmail?: string | null;
    } | null> | null;
    summary: Array<{
      __typename?: 'CollectionSummary';
      id: string;
      summaryType: string;
      exchangeKey?: string | null;
      primaryCurrency?: string | null;
      secondaryCurrency?: string | null;
      primaryValue: number;
      secondaryVaue: number;
      isCurrency: boolean;
      name: string;
      description: string;
    }>;
    totals: Array<{
      __typename?: 'CollectionSummary';
      id: string;
      summaryType: string;
      exchangeKey?: string | null;
      primaryCurrency?: string | null;
      secondaryCurrency?: string | null;
      primaryValue: number;
      secondaryVaue: number;
      isCurrency: boolean;
      name: string;
      description: string;
    }>;
  } | null;
};

export type GetReceiptDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetReceiptDataQuery = {
  __typename?: 'Query';
  receiptReport?: {
    __typename?: 'Receipt';
    header: {
      __typename?: 'ReceiptHeader';
      clientName: string;
      baseCurrency: string;
      receiptNumber: string;
      date: string;
      dateName: string;
      status: string;
      purpose: string;
      isBonus: boolean;
      clientType: string;
      receiptLabel: string;
      receiptLineOne?: string | null;
      receiptLineTwo?: string | null;
      receiptFootnote?: string | null;
      submittedAgentId: string;
      submittedAgentName: string;
      submittedAgentEmail: string;
      submittedAgentPhone?: string | null;
      tenantCode?: string | null;
      transactionType?: string | null;
      billDate?: string | null;
      dueDate?: string | null;
      merchant?: string | null;
      billNumber?: string | null;
      billServiceName?: string | null;
      billServiceNumber?: string | null;
    };
    transaction: {
      __typename?: 'ReceiptTransaction';
      receiveCurrency: string;
      sendCurrency: string;
      senderName: string;
      senderPhone: string;
      receiverName: string;
      receiverPhone: string;
    };
    remitance: {
      __typename?: 'Remitance';
      feeAmount: number;
      receiveAmount: number;
      sendAmount: number;
      exchangeRate: number;
    };
  } | null;
};

export type GetGlobalUsageReportQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
}>;

export type GetGlobalUsageReportQuery = {
  __typename?: 'Query';
  globalUsageReport?: {
    __typename?: 'CollectionReport';
    keys?: Array<{
      __typename?: 'CurrencyKey';
      toCurrency: string;
      fromCurrency: string;
      exchangeKey: string;
    } | null> | null;
    collections?: Array<{
      __typename?: 'CollectionInfo';
      agentName: string;
      exchangeKey?: string | null;
      primaryCurrency?: string | null;
      secondaryCurrency?: string | null;
      fromAmount: number;
      toAmount: number;
      commission: number;
      email?: string | null;
      managerName?: string | null;
      managerEmail?: string | null;
    } | null> | null;
    summary: Array<{
      __typename?: 'CollectionSummary';
      id: string;
      summaryType: string;
      exchangeKey?: string | null;
      primaryCurrency?: string | null;
      secondaryCurrency?: string | null;
      primaryValue: number;
      secondaryVaue: number;
      isCurrency: boolean;
      name: string;
      description: string;
    }>;
    totals: Array<{
      __typename?: 'CollectionSummary';
      id: string;
      summaryType: string;
      exchangeKey?: string | null;
      primaryCurrency?: string | null;
      secondaryCurrency?: string | null;
      primaryValue: number;
      secondaryVaue: number;
      isCurrency: boolean;
      name: string;
      description: string;
    }>;
  } | null;
};

export type ResetAgentBalanceMutationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ResetAgentBalanceMutationMutation = {
  __typename?: 'Mutation';
  resetAgentBalance?: {
    __typename?: 'AgentResponse';
    success: boolean;
    message: string;
    code: string;
  } | null;
};

export type SatelliteAgentListItemFragmentFragment = {
  __typename?: 'Agent';
  id: string;
  tenant: string;
  name: string;
  limit?: number | null;
  phone: string;
  email: string;
  balance?: Array<{
    __typename?: 'AccountBalance';
    label: string;
    symbol: string;
    name: string;
    value: number;
  } | null> | null;
} & { ' $fragmentName'?: 'SatelliteAgentListItemFragmentFragment' };

export type SatelliteAgentsQueryVariables = Exact<{ [key: string]: never }>;

export type SatelliteAgentsQuery = {
  __typename?: 'Query';
  satelliteAgents?: Array<
    | ({ __typename?: 'Agent' } & {
        ' $fragmentRefs'?: {
          SatelliteAgentListItemFragmentFragment: SatelliteAgentListItemFragmentFragment;
        };
      })
    | null
  > | null;
};

export type GetServiceBillsQueryVariables = Exact<{
  merchant: Scalars['String'];
  serviceId: Scalars['Int'];
  serviceNumber: Scalars['String'];
}>;

export type GetServiceBillsQuery = {
  __typename?: 'Query';
  serviceBills?: Array<{
    __typename?: 'ServiceBill';
    payItemId: string;
    amountType: string;
    localCur: string;
    amountLocalCur: number;
    billNumber: string;
    customerNumber?: string | null;
    billMonth: string;
    billYear: string;
    billDate?: string | null;
    billDueDate?: string | null;
    payItemDescr?: string | null;
    billType?: string | null;
    penaltyAmount?: number | null;
    payOrder?: number | null;
  } | null> | null;
};

export type GetTransactionServiceQueryVariables = Exact<{
  serviceId: Scalars['ID'];
}>;

export type GetTransactionServiceQuery = {
  __typename?: 'Query';
  service?: {
    __typename?: 'TransactionService';
    serviceid: number;
    merchant: string;
    title: string;
    description: string;
    category: string;
    country: string;
    localCur: string;
    type: string;
    status: string;
    isReqCustomerName?: boolean | null;
    isReqCustomerAddress?: boolean | null;
    isReqCustomerNumber?: boolean | null;
    isReqServiceNumber?: boolean | null;
    denomination?: number | null;
    isVerifiable?: boolean | null;
    validationMask?: string | null;
    hint?: Array<{
      __typename?: 'I18nText';
      language: string;
      localText?: string | null;
    } | null> | null;
    labelCustomerNumber?: Array<{
      __typename?: 'I18nText';
      language: string;
      localText?: string | null;
    } | null> | null;
    labelServiceNumber?: Array<{
      __typename?: 'I18nText';
      language: string;
      localText?: string | null;
    } | null> | null;
  } | null;
};

export type GetServicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetServicesQuery = {
  __typename?: 'Query';
  services?: Array<{
    __typename?: 'TransactionService';
    serviceid: number;
    merchant: string;
    title: string;
    description: string;
    category: string;
    type: string;
    status: string;
    labelCustomerNumber?: Array<{
      __typename?: 'I18nText';
      localText?: string | null;
    } | null> | null;
    labelServiceNumber?: Array<{
      __typename?: 'I18nText';
      localText?: string | null;
    } | null> | null;
  } | null> | null;
};

export type SettingsQueryVariables = Exact<{ [key: string]: never }>;

export type SettingsQuery = {
  __typename?: 'Query';
  agent?: {
    __typename?: 'Agent';
    id: string;
    email: string;
    name: string;
    role?: AgentRole | null;
    tenant: string;
  } | null;
  tenant?: { __typename?: 'Tenant'; name: string; id: string } | null;
};

export type BalancesQueryVariables = Exact<{ [key: string]: never }>;

export type BalancesQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    balance: number;
    currency: string;
  } | null;
  accountBalance?: Array<{
    __typename?: 'AccountBalance';
    label: string;
    symbol: string;
    name: string;
    value: number;
  } | null> | null;
};

export type GetTenantNamesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTenantNamesQuery = {
  __typename?: 'Query';
  tenants?: Array<{
    __typename?: 'Tenant';
    id: string;
    name: string;
  } | null> | null;
};

export type SetAdminAgentTenantMutationVariables = Exact<{
  id: Scalars['ID'];
  tenantId: Scalars['String'];
}>;

export type SetAdminAgentTenantMutation = {
  __typename?: 'Mutation';
  setAdminAgentTenant?: {
    __typename?: 'BasicResponse';
    code: string;
    message: string;
    success: boolean;
  } | null;
};

export type GetTransactionFormDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTransactionFormDataQuery = {
  __typename?: 'Query';
  tenant?: {
    __typename?: 'Tenant';
    id: string;
    currency: string;
    maxBonus: number;
    rateChangeThreshold1?: number | null;
    rateChangeThreshold2?: number | null;
    rateChangeThreshold3?: number | null;
    rates?: Array<{
      __typename?: 'Rate';
      code?: string | null;
      source: string;
      destination: string;
      rate: number;
    } | null> | null;
  } | null;
  agent?: {
    __typename?: 'Agent';
    role?: AgentRole | null;
    limit?: number | null;
  } | null;
  account?: { __typename?: 'Account'; balance: number } | null;
};

export type TransactionFormTransactionFragment = {
  __typename?: 'Transaction';
  id: string;
  exchangeRate: number;
  purpose: string;
  isBonus?: boolean | null;
  status: TransactionStatus;
  sendMode: SendMode;
  requestCount?: number | null;
  sender?:
    | { __typename?: 'Agent'; id: string; name: string; phone: string }
    | { __typename?: 'RegisteredUser'; id: string; name: string; phone: string }
    | null;
  recipient?:
    | { __typename?: 'Agent'; id: string; name: string; phone: string }
    | { __typename?: 'RegisteredUser'; id: string; name: string; phone: string }
    | null;
  sent: { __typename?: 'Money'; amount: number; currency: string };
  received: { __typename?: 'Money'; amount: number; currency: string };
  historicals?: {
    __typename?: 'HistoricalUser';
    senderName?: string | null;
    recipientName?: string | null;
  } | null;
  bill?: {
    __typename?: 'Bill';
    billNumber?: string | null;
    amount?: number | null;
    date?: string | null;
    dueDate?: string | null;
    customerNumber?: string | null;
    merchant?: string | null;
    payItemDesc?: string | null;
    payItemId?: string | null;
    serviceId?: string | null;
    serviceName?: string | null;
    serviceNumber?: string | null;
  } | null;
} & { ' $fragmentName'?: 'TransactionFormTransactionFragment' };

export type GetTransactionQueryVariables = Exact<{
  transactionId: Scalars['ID'];
}>;

export type GetTransactionQuery = {
  __typename?: 'Query';
  transaction?:
    | ({ __typename?: 'Transaction' } & {
        ' $fragmentRefs'?: {
          TransactionFormTransactionFragment: TransactionFormTransactionFragment;
        };
      })
    | null;
};

export type RequestItemTransactionFragment = ({
  __typename?: 'Transaction';
  ptn?: string | null;
  state?: UiState | null;
  errors?: Array<{
    __typename?: 'UiError';
    code: number;
    message: string;
  } | null> | null;
} & {
  ' $fragmentRefs'?: {
    TransactionFormTransactionFragment: TransactionFormTransactionFragment;
  };
}) & { ' $fragmentName'?: 'RequestItemTransactionFragment' };

export type TransactionQueryVariables = Exact<{
  transactionId: Scalars['ID'];
}>;

export type TransactionQuery = {
  __typename?: 'Query';
  transaction?:
    | ({ __typename?: 'Transaction'; dateCreated: string } & {
        ' $fragmentRefs'?: {
          RequestItemTransactionFragment: RequestItemTransactionFragment;
        };
      })
    | null;
};

export type RequestsList_QueryFragmentFragment = {
  __typename?: 'Query';
  agentTransactions?: Array<
    | ({
        __typename?: 'Transaction';
        dateCreated: string;
        requestCount?: number | null;
      } & {
        ' $fragmentRefs'?: {
          RequestItemTransactionFragment: RequestItemTransactionFragment;
        };
      })
    | null
  > | null;
} & { ' $fragmentName'?: 'RequestsList_QueryFragmentFragment' };

export type AddTransactionMutationVariables = Exact<{
  senderId: Scalars['String'];
  senderName: Scalars['String'];
  sendingPhone: Scalars['String'];
  recipientId: Scalars['String'];
  recipientName: Scalars['String'];
  destinationPhone: Scalars['String'];
  sendAmount: Scalars['Float'];
  sendCurrency: SendCurrency;
  receiveAmount: Scalars['Float'];
  receiveCurrency: DestinationCurrency;
  exchangeRate: Scalars['Float'];
  sendMode: SendMode;
  isBonus: Scalars['Boolean'];
  purpose: Scalars['String'];
  billNumber: Scalars['String'];
  billAmount: Scalars['Float'];
  billDate: Scalars['String'];
  billDueDate: Scalars['String'];
  billCustomerNumber: Scalars['String'];
  billMerchant: Scalars['String'];
  billPayItemDesc: Scalars['String'];
  billPayItemId: Scalars['String'];
  billServiceId: Scalars['String'];
  billServiceName: Scalars['String'];
  billServiceNumber: Scalars['String'];
}>;

export type AddTransactionMutation = {
  __typename?: 'Mutation';
  addTransaction?:
    | ({ __typename?: 'TransactionResponse' } & {
        ' $fragmentRefs'?: {
          TransactionResponseFragmentFragment: TransactionResponseFragmentFragment;
        };
      })
    | null;
};

export type UpdateTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
  senderId: Scalars['String'];
  senderName: Scalars['String'];
  sendingPhone: Scalars['String'];
  recipientId: Scalars['String'];
  recipientName: Scalars['String'];
  destinationPhone: Scalars['String'];
  sendAmount: Scalars['Float'];
  sendCurrency: SendCurrency;
  receiveAmount: Scalars['Float'];
  receiveCurrency: DestinationCurrency;
  exchangeRate: Scalars['Float'];
  sendMode: SendMode;
  isBonus: Scalars['Boolean'];
  purpose: Scalars['String'];
  billNumber: Scalars['String'];
  billAmount: Scalars['Float'];
  billDate: Scalars['String'];
  billDueDate: Scalars['String'];
  billCustomerNumber: Scalars['String'];
  billMerchant: Scalars['String'];
  billPayItemDesc: Scalars['String'];
  billPayItemId: Scalars['String'];
  billServiceId: Scalars['String'];
  billServiceName: Scalars['String'];
  billServiceNumber: Scalars['String'];
}>;

export type UpdateTransactionMutation = {
  __typename?: 'Mutation';
  updateTransaction?:
    | ({ __typename?: 'TransactionResponse' } & {
        ' $fragmentRefs'?: {
          TransactionResponseFragmentFragment: TransactionResponseFragmentFragment;
        };
      })
    | null;
};

export type GetTransactionsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  startPage?: InputMaybe<Scalars['Int']>;
}>;

export type GetTransactionsQuery = { __typename?: 'Query' } & {
  ' $fragmentRefs'?: {
    RequestsList_QueryFragmentFragment: RequestsList_QueryFragmentFragment;
  };
};

export type Transaction_RowFragmentFragment = ({
  __typename?: 'Transaction';
  dateCreated: string;
  state?: UiState | null;
  relevantAgent?: { __typename?: 'Agent'; email: string } | null;
  errors?: Array<{
    __typename?: 'UiError';
    code: number;
    message: string;
  } | null> | null;
} & {
  ' $fragmentRefs'?: {
    TransactionFormTransactionFragment: TransactionFormTransactionFragment;
  };
}) & { ' $fragmentName'?: 'Transaction_RowFragmentFragment' };

export type TransactionResponseFragmentFragment = {
  __typename?: 'TransactionResponse';
  code: string;
  message: string;
  success: boolean;
  transaction?:
    | ({ __typename?: 'Transaction' } & {
        ' $fragmentRefs'?: {
          Transaction_RowFragmentFragment: Transaction_RowFragmentFragment;
        };
      })
    | null;
} & { ' $fragmentName'?: 'TransactionResponseFragmentFragment' };

export type GetAllTransactionsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  startPage?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
}>;

export type GetAllTransactionsQuery = {
  __typename?: 'Query';
  transactions?: Array<
    | ({ __typename?: 'Transaction' } & {
        ' $fragmentRefs'?: {
          Transaction_RowFragmentFragment: Transaction_RowFragmentFragment;
        };
      })
    | null
  > | null;
};

export type ExportTransactionsQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
}>;

export type ExportTransactionsQuery = {
  __typename?: 'Query';
  exportTransactions?: string | null;
};

export type ConfirmTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ConfirmTransactionMutation = {
  __typename?: 'Mutation';
  confirmTransaction?: {
    __typename?: 'TransactionResponse';
    success: boolean;
    message: string;
    transaction?: {
      __typename?: 'Transaction';
      id: string;
      status: TransactionStatus;
    } | null;
  } | null;
};

export type SubmitTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type SubmitTransactionMutation = {
  __typename?: 'Mutation';
  submitTransaction?: {
    __typename?: 'TransactionResponse';
    success: boolean;
    message: string;
    transaction?: {
      __typename?: 'Transaction';
      id: string;
      status: TransactionStatus;
      ptn?: string | null;
    } | null;
  } | null;
};

export type CancelTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type CancelTransactionMutation = {
  __typename?: 'Mutation';
  cancelTransaction?: {
    __typename?: 'TransactionResponse';
    success: boolean;
    message: string;
    transaction?: {
      __typename?: 'Transaction';
      id: string;
      status: TransactionStatus;
    } | null;
  } | null;
};

export type ConfirmAndSubmitTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ConfirmAndSubmitTransactionMutation = {
  __typename?: 'Mutation';
  confirmAndSubmitTransaction?: {
    __typename?: 'TransactionResponse';
    success: boolean;
    message: string;
    transaction?: {
      __typename?: 'Transaction';
      id: string;
      status: TransactionStatus;
    } | null;
  } | null;
};

export type UserSearchResultFragment = {
  __typename?: 'RegisteredUser';
  id: string;
  name: string;
  phone: string;
  sender?: string | null;
} & { ' $fragmentName'?: 'UserSearchResultFragment' };

export type GetUsersMatchingTextQueryVariables = Exact<{
  sender?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;

export type GetUsersMatchingTextQuery = {
  __typename?: 'Query';
  users?: Array<
    | ({ __typename?: 'RegisteredUser' } & {
        ' $fragmentRefs'?: {
          UserSearchResultFragment: UserSearchResultFragment;
        };
      })
    | null
  > | null;
};

export type VerifyPhoneQueryVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;

export type VerifyPhoneQuery = {
  __typename?: 'Query';
  verifyPhone?: {
    __typename?: 'PhoneVerification';
    status: string;
    name?: string | null;
    phone: string;
  } | null;
};

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetUserByIdQuery = {
  __typename?: 'Query';
  user?:
    | ({ __typename?: 'RegisteredUser' } & {
        ' $fragmentRefs'?: {
          UserSearchResultFragment: UserSearchResultFragment;
        };
      })
    | null;
};

export type AddUserMutationVariables = Exact<{
  sender: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
}>;

export type AddUserMutation = {
  __typename?: 'Mutation';
  addUser?: {
    __typename?: 'RegisteredUserResponse';
    success: boolean;
    code: string;
    message: string;
    user?: {
      __typename?: 'RegisteredUser';
      id: string;
      name: string;
      phone: string;
      sender?: string | null;
    } | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?: {
    __typename?: 'RegisteredUserResponse';
    success: boolean;
    code: string;
    message: string;
    user?: {
      __typename?: 'RegisteredUser';
      id: string;
      name: string;
      phone: string;
    } | null;
  } | null;
};

export type CountTransactionsQueryVariables = Exact<{
  senderId: Scalars['String'];
  recipientId: Scalars['String'];
}>;

export type CountTransactionsQuery = {
  __typename?: 'Query';
  countTransactions?: number | null;
};

export type CurrentAgentQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentAgentQuery = {
  __typename?: 'Query';
  agent?: {
    __typename?: 'Agent';
    id: string;
    tenant: string;
    role?: AgentRole | null;
  } | null;
};

export const MyClientsSearchResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyClientsSearchResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RegisteredUser' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'senderRegisteredUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyClientsSearchResultFragment, unknown>;
export const Tenant_RowFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tenant_RowFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Tenant' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'commission' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxBonus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateThreshold' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateChangeThreshold1' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateChangeThreshold2' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rateChangeThreshold3' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptLabel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptLineTwo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiptFootnote' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Tenant_RowFragmentFragment, unknown>;
export const ClientAgent_ItemFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientAgent_ItemFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Agent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'superAgent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientAgent_ItemFragmentFragment, unknown>;
export const ClientRate_ItemFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ClientRate_ItemFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Rate' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destination' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rate' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientRate_ItemFragmentFragment, unknown>;
export const SatelliteAgentListItemFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SatelliteAgentListItemFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Agent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tenant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'balance' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SatelliteAgentListItemFragmentFragment, unknown>;
export const TransactionFormTransactionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TransactionFormTransaction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Transaction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'received' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exchangeRate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isBonus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'historicals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'senderName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipientName' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bill' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'billNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'merchant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'payItemDesc' } },
                { kind: 'Field', name: { kind: 'Name', value: 'payItemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionFormTransactionFragment, unknown>;
export const RequestItemTransactionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RequestItemTransaction' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Transaction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ptn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TransactionFormTransaction' },
          },
        ],
      },
    },
    ...TransactionFormTransactionFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<RequestItemTransactionFragment, unknown>;
export const RequestsList_QueryFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RequestsList_QueryFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Query' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agentTransactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchText' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startPage' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'startPage' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateCreated' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestCount' },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RequestItemTransaction' },
                },
              ],
            },
          },
        ],
      },
    },
    ...RequestItemTransactionFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<RequestsList_QueryFragmentFragment, unknown>;
export const Transaction_RowFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Transaction_RowFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Transaction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateCreated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'relevantAgent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'errors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TransactionFormTransaction' },
          },
        ],
      },
    },
    ...TransactionFormTransactionFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<Transaction_RowFragmentFragment, unknown>;
export const TransactionResponseFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TransactionResponseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TransactionResponse' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transaction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Transaction_RowFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...Transaction_RowFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<TransactionResponseFragmentFragment, unknown>;
export const UserSearchResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserSearchResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RegisteredUser' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sender' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSearchResultFragment, unknown>;
export const IsValidAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IsValidAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isValidAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsValidAgentQuery, IsValidAgentQueryVariables>;
export const RegisterAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'agentToken' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'agentToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'agentToken' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterAgentMutation,
  RegisterAgentMutationVariables
>;
export const SearchMyClientsUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchMyClientsUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchText' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'viewType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchText' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'viewType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'viewType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyClientsSearchResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...MyClientsSearchResultFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SearchMyClientsUsersQuery,
  SearchMyClientsUsersQueryVariables
>;
export const GetTenantsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenants' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Tenant_RowFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...Tenant_RowFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetTenantsQuery, GetTenantsQueryVariables>;
export const AgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Agents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tenantId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ClientAgent_ItemFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...ClientAgent_ItemFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<AgentsQuery, AgentsQueryVariables>;
export const DeactivateAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'agentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'agentId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivateAgentMutation,
  DeactivateAgentMutationVariables
>;
export const RatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Rates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tenantId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ClientRate_ItemFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...ClientRate_ItemFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<RatesQuery, RatesQueryVariables>;
export const DeleteRateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rateId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tenantId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'rateId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRateMutation, DeleteRateMutationVariables>;
export const ReadTenantForRateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReadTenantForRate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReadTenantForRateQuery,
  ReadTenantForRateQueryVariables
>;
export const GetBalanceLedgerReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBalanceLedgerReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'balanceLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'to' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateCreated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'credit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rateCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agentId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'correlationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBalanceLedgerReportQuery,
  GetBalanceLedgerReportQueryVariables
>;
export const GetAgentUsageReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAgentUsageReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'agentId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agentUsageReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'to' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'agentId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'agentId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'keys' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'toCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fromCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agentName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fromAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'toAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'managerName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'managerEmail' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summaryType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryValue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryVaue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCurrency' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summaryType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryValue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryVaue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCurrency' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAgentUsageReportQuery,
  GetAgentUsageReportQueryVariables
>;
export const GetReceiptDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetReceiptData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'receiptReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'header' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clientName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'baseCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiptNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'purpose' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isBonus' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'clientType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiptLabel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiptLineOne' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiptLineTwo' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiptFootnote' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submittedAgentId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submittedAgentName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submittedAgentEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submittedAgentPhone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenantCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dueDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'merchant' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billServiceName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billServiceNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiveCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'senderName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'senderPhone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiverName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiverPhone' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remitance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'feeAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receiveAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeRate' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReceiptDataQuery, GetReceiptDataQueryVariables>;
export const GetGlobalUsageReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGlobalUsageReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'globalUsageReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'to' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'keys' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'toCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fromCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agentName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fromAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'toAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commission' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'managerName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'managerEmail' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summaryType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryValue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryVaue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCurrency' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summaryType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exchangeKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryCurrency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryValue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'secondaryVaue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCurrency' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetGlobalUsageReportQuery,
  GetGlobalUsageReportQueryVariables
>;
export const ResetAgentBalanceMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetAgentBalanceMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetAgentBalance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetAgentBalanceMutationMutation,
  ResetAgentBalanceMutationMutationVariables
>;
export const SatelliteAgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SatelliteAgents' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'satelliteAgents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SatelliteAgentListItemFragment',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...SatelliteAgentListItemFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  SatelliteAgentsQuery,
  SatelliteAgentsQueryVariables
>;
export const GetServiceBillsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetServiceBills' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'merchant' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'serviceId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'serviceNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceBills' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'merchant' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'merchant' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serviceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'serviceId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'serviceNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'serviceNumber' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'payItemId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localCur' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'amountLocalCur' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'billNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'billMonth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'billDueDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payItemDescr' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'billType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'penaltyAmount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'payOrder' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetServiceBillsQuery,
  GetServiceBillsQueryVariables
>;
export const GetTransactionServiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTransactionService' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'serviceId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'service' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'serviceId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serviceid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merchant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'localCur' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isReqCustomerName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isReqCustomerAddress' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isReqCustomerNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isReqServiceNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'denomination' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isVerifiable' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validationMask' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hint' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'language' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localText' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelCustomerNumber' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'language' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localText' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelServiceNumber' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'language' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localText' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTransactionServiceQuery,
  GetTransactionServiceQueryVariables
>;
export const GetServicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetServices' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'services' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'serviceid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merchant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelCustomerNumber' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localText' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelServiceNumber' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'localText' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetServicesQuery, GetServicesQueryVariables>;
export const SettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Settings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenant' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsQuery, SettingsQueryVariables>;
export const BalancesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Balances' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountBalance' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BalancesQuery, BalancesQueryVariables>;
export const GetTenantNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTenantNames' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenants' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTenantNamesQuery, GetTenantNamesQueryVariables>;
export const SetAdminAgentTenantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAdminAgentTenant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tenantId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAdminAgentTenant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tenantId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetAdminAgentTenantMutation,
  SetAdminAgentTenantMutationVariables
>;
export const GetTransactionFormDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTransactionFormData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tenant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxBonus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rateChangeThreshold1' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rateChangeThreshold2' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rateChangeThreshold3' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'source' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rate' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'balance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTransactionFormDataQuery,
  GetTransactionFormDataQueryVariables
>;
export const GetTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'transactionId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'transactionId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TransactionFormTransaction' },
                },
              ],
            },
          },
        ],
      },
    },
    ...TransactionFormTransactionFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetTransactionQuery, GetTransactionQueryVariables>;
export const TransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Transaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'transactionId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'transactionId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateCreated' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RequestItemTransaction' },
                },
              ],
            },
          },
        ],
      },
    },
    ...RequestItemTransactionFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<TransactionQuery, TransactionQueryVariables>;
export const AddTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendingPhone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'destinationPhone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendCurrency' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendCurrency' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'receiveAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'receiveCurrency' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DestinationCurrency' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exchangeRate' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendMode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendMode' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isBonus' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'purpose' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billDueDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billCustomerNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billMerchant' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billPayItemDesc' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billPayItemId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billServiceId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billServiceName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billServiceNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTransaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'senderId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'senderName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendingPhone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendingPhone' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipientId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recipientId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipientName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recipientName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destinationPhone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'destinationPhone' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendAmount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendCurrency' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendCurrency' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiveAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'receiveAmount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiveCurrency' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'receiveCurrency' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exchangeRate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'exchangeRate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendMode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendMode' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isBonus' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isBonus' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'purpose' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'purpose' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billAmount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billDueDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billDueDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billCustomerNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billCustomerNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billMerchant' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billMerchant' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billPayItemDesc' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billPayItemDesc' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billPayItemId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billPayItemId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billServiceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billServiceId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billServiceName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billServiceName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billServiceNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billServiceNumber' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TransactionResponseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...TransactionResponseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  AddTransactionMutation,
  AddTransactionMutationVariables
>;
export const UpdateTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendingPhone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'destinationPhone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendCurrency' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendCurrency' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'receiveAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'receiveCurrency' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DestinationCurrency' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exchangeRate' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sendMode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendMode' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isBonus' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'purpose' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billDueDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billCustomerNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billMerchant' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billPayItemDesc' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billPayItemId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billServiceId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billServiceName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billServiceNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTransaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'senderId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'senderName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendingPhone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendingPhone' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipientId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recipientId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipientName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recipientName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destinationPhone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'destinationPhone' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendAmount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendCurrency' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendCurrency' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiveAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'receiveAmount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiveCurrency' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'receiveCurrency' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exchangeRate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'exchangeRate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sendMode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sendMode' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isBonus' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isBonus' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'purpose' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'purpose' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billAmount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billAmount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billDueDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billDueDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billCustomerNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billCustomerNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billMerchant' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billMerchant' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billPayItemDesc' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billPayItemDesc' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billPayItemId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billPayItemId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billServiceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billServiceId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billServiceName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billServiceName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billServiceNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billServiceNumber' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'TransactionResponseFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...TransactionResponseFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  UpdateTransactionMutation,
  UpdateTransactionMutationVariables
>;
export const GetTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchText' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startPage' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'RequestsList_QueryFragment' },
          },
        ],
      },
    },
    ...RequestsList_QueryFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetTransactionsQuery,
  GetTransactionsQueryVariables
>;
export const GetAllTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchText' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startPage' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortBy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortOrder' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchText' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startPage' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'startPage' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortBy' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrder' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortOrder' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Transaction_RowFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...Transaction_RowFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetAllTransactionsQuery,
  GetAllTransactionsQueryVariables
>;
export const ExportTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportTransactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'from' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'to' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportTransactionsQuery,
  ExportTransactionsQueryVariables
>;
export const ConfirmTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmTransaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmTransactionMutation,
  ConfirmTransactionMutationVariables
>;
export const SubmitTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitTransaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ptn' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitTransactionMutation,
  SubmitTransactionMutationVariables
>;
export const CancelTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelTransaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelTransactionMutation,
  CancelTransactionMutationVariables
>;
export const ConfirmAndSubmitTransactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmAndSubmitTransaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmAndSubmitTransaction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transaction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmAndSubmitTransactionMutation,
  ConfirmAndSubmitTransactionMutationVariables
>;
export const GetUsersMatchingTextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUsersMatchingText' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sender' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchText' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sender' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sender' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchText' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserSearchResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserSearchResultFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetUsersMatchingTextQuery,
  GetUsersMatchingTextQueryVariables
>;
export const VerifyPhoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerifyPhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phoneNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyPhone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phoneNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phoneNumber' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyPhoneQuery, VerifyPhoneQueryVariables>;
export const GetUserByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserSearchResult' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserSearchResultFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const AddUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sender' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sender' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sender' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phone' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sender' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddUserMutation, AddUserMutationVariables>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phone' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const CountTransactionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CountTransactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countTransactions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'senderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'senderId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'recipientId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'recipientId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountTransactionsQuery,
  CountTransactionsQueryVariables
>;
export const CurrentAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentAgent' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tenant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentAgentQuery, CurrentAgentQueryVariables>;
export const namedOperations = {
  Query: {
    IsValidAgent: 'IsValidAgent',
    SearchMyClientsUsers: 'SearchMyClientsUsers',
    GetTenants: 'GetTenants',
    Agents: 'Agents',
    Rates: 'Rates',
    ReadTenantForRate: 'ReadTenantForRate',
    GetBalanceLedgerReport: 'GetBalanceLedgerReport',
    GetAgentUsageReport: 'GetAgentUsageReport',
    GetReceiptData: 'GetReceiptData',
    GetGlobalUsageReport: 'GetGlobalUsageReport',
    SatelliteAgents: 'SatelliteAgents',
    GetServiceBills: 'GetServiceBills',
    GetTransactionService: 'GetTransactionService',
    GetServices: 'GetServices',
    Settings: 'Settings',
    Balances: 'Balances',
    GetTenantNames: 'GetTenantNames',
    GetTransactionFormData: 'GetTransactionFormData',
    GetTransaction: 'GetTransaction',
    Transaction: 'Transaction',
    GetTransactions: 'GetTransactions',
    GetAllTransactions: 'GetAllTransactions',
    ExportTransactions: 'ExportTransactions',
    GetUsersMatchingText: 'GetUsersMatchingText',
    VerifyPhone: 'VerifyPhone',
    GetUserById: 'GetUserById',
    CountTransactions: 'CountTransactions',
    CurrentAgent: 'CurrentAgent',
  },
  Mutation: {
    RegisterAgent: 'RegisterAgent',
    DeactivateAgent: 'DeactivateAgent',
    DeleteRate: 'DeleteRate',
    ResetAgentBalanceMutation: 'ResetAgentBalanceMutation',
    SetAdminAgentTenant: 'SetAdminAgentTenant',
    AddTransaction: 'AddTransaction',
    UpdateTransaction: 'UpdateTransaction',
    ConfirmTransaction: 'ConfirmTransaction',
    SubmitTransaction: 'SubmitTransaction',
    CancelTransaction: 'CancelTransaction',
    ConfirmAndSubmitTransaction: 'ConfirmAndSubmitTransaction',
    AddUser: 'AddUser',
    UpdateUser: 'UpdateUser',
  },
  Fragment: {
    MyClientsSearchResult: 'MyClientsSearchResult',
    Tenant_RowFragment: 'Tenant_RowFragment',
    ClientAgent_ItemFragment: 'ClientAgent_ItemFragment',
    ClientRate_ItemFragment: 'ClientRate_ItemFragment',
    SatelliteAgentListItemFragment: 'SatelliteAgentListItemFragment',
    TransactionFormTransaction: 'TransactionFormTransaction',
    RequestItemTransaction: 'RequestItemTransaction',
    RequestsList_QueryFragment: 'RequestsList_QueryFragment',
    Transaction_RowFragment: 'Transaction_RowFragment',
    TransactionResponseFragment: 'TransactionResponseFragment',
    UserSearchResult: 'UserSearchResult',
  },
};
